import api, { unwrap } from './client';

// Plan charges sociales 24 mois — CALCULÉ PAR LE SERVEUR (moteur migré du
// JavaScript le 2026-08-21). Les écrans LISENT ; plus aucun calcul local ni
// série publiée. Deux portes, un seul service :
//   · Finance (bilan, plan de liquidité, vue Charges sociales) — agrégé.
//   · People (Plan masse salariale…) — filtrable par personnes.
export const getSocialChargesPlan = (tenantId, year) =>
  unwrap(api.get(`/financials/social-charges-plan/${tenantId}`, { params: { year } }));

// `personIds` null = pas de filtre ; tableau (même vide) = filtre exact.
// `ratesYear` : taux de charges empruntés à cette année (évolution
// pluriannuelle — années futures « estimées » avec les taux de N).
// `withMovements` false = BASELINE (contrats seuls). Le graphique de variation
// compare les deux séries ; les deux viennent du MÊME moteur serveur.
export const getSocialChargesPlanPeople = (tenantId, year, personIds = null, ratesYear = null, withMovements = true) =>
  unwrap(api.get(`/hr/social-charges-plan/${tenantId}`, {
    params: {
      year,
      ...(personIds ? { person_ids: personIds.join(',') } : {}),
      ...(ratesYear != null ? { rates_year: ratesYear } : {}),
      ...(withMovements ? {} : { movements: 0 }),
    },
  }));
